import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'strReplace',
    standalone: false
})
export class StrReplacePipe implements PipeTransform {

  transform(value: string, strToReplace: string, replacementStr: string): string {
    if (typeof value !== 'string' || !value || !strToReplace || !replacementStr) {
      return value;
    }

    return value.replace(new RegExp(strToReplace, 'g'), replacementStr);
  }

}
